<mat-card>
  <mat-card-header>
    <mat-card-title class="flex flex-row justify-between items-start">
      <div>
        {{ '+EDIT_DEVICE_NAME_MODAL.LABEL' | translate }}
      </div>
      <button
        mat-icon-button
        gtm="onClose"
        gtmAction="Edit name"
        gtmCategory="editHeatingCircuitModal"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="flex flex-row gap-[16px] justify-start items-start">
    <mat-form-field mat-input-height-large-label>
      <mat-label>{{ '+EDIT_DEVICE_NAME_MODAL.TITLE' | translate }}</mat-label>
      <input
        #input
        gtm="onTextField"
        gtmAction="Device name"
        gtmCategory="editDeviceNameModal"
        [gtmOn]="['change', 'focus', 'blur']"
        [formControl]="deviceNameForm"
        [(ngModel)]="currentDeviceName"
        matInput
        autocomplete="off"
        maxlength="40"
        fieldTextContentTooltip
      />
      <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
        <mat-icon>cancel</mat-icon>
      </button>
      <mat-error *ngIf="deviceNameForm.hasError('notUnique')">
        {{ '+EDIT_DEVICE_NAME_MODAL.NAME_NOT_UNIQUE' | translate }}
      </mat-error>
      <mat-error *ngIf="deviceNameForm.hasError('pattern')">
        {{ '+EDIT_DEVICE_NAME_MODAL.ERROR_SPECIAL_CHARACTERS' | translate }}
      </mat-error>
      <mat-hint align="end">{{ input.value.length || 0 }}/{{ 40 }}</mat-hint>
    </mat-form-field>
    <button
      class="save-btn lt-md:!hidden flex-[150px] max-w-[150px]"
      mat-raised-button
      gtm="onSave"
      gtmAction="Edit device name"
      gtmCategory="editDeviceNameModal"
      color="primary"
      (click)="onSaveDeviceName()"
      [disabled]="!deviceNameForm.valid"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-content>
  <mat-card-actions class="flex flex-col gt-sm:!hidden gap-[8px] justify-start items-center">
    <button
      mat-raised-button
      gtm="onSave"
      gtmAction="Edit device name"
      gtmCategory="editDeviceNameModal"
      color="primary"
      (click)="onSaveDeviceName()"
      [disabled]="!deviceNameForm.valid"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
